import { all } from 'redux-saga/effects'
import programSagas from './Program'
import authSagas from './Auth'
import userSagas from './User'

export default function* rootSaga(getState) {
  yield all([programSagas(), userSagas(), authSagas()])
}
